import Utils from '@/ecm/common/Utils'
export default class ContentTypeAlertAction {
    constructor (dto) {
        this.uuid = Utils.object.getUUID()
        this.defFieldCode = ''
        this.value = ''

        if (dto) {
            this.value = dto.Value
            this.defFieldCode = dto.DefFieldCode
        }
    }

    toDto () {
        return {
            Value: this.value,
            DefFieldCode: this.defFieldCode,
        }
    }
}
